
export default {
  name: 'AtomStatementsSlider',
  props: {}
}
